module.exports = __webpack_public_path__ + "static/media/IMG-2.6c4e77b4.jpg";